import styled from "styled-components";

export const Content = styled.div`
  .filtros{
    display: flex;
    gap: 8px;
    margin: 8px 0 4px;

    select{
      flex: 1;
      min-width: 0;
      margin: 0;
      height: 34px;
      padding: 0 8px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 13px;
      background: #fff;
    }
  }

  .resumo{
    display: block;
    margin: 10px 0 0;
    font-size: 12px;
    color: #4D4F50;
  }

  .feedback{
    display: block;
    margin-top: 10px;
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 12px;
    background: #F1F8F2;
    border: 1px solid #CFE6D3;
    color: #1f7a33;
  }

  .erro-lista{
    display: block;
    margin-top: 10px;
    font-size: 12px;
    color: #C43333;
  }

  .vazio{
    display: block;
    margin: 28px 0;
    text-align: center;
    font-size: 13px;
    color: #4D4F50;
  }

  .more{
    color: var(--primary-color);
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    cursor: pointer;
    background: transparent;
    border: none;
    margin: 12px 0 0;
    font-size: 14px;

    &:hover{ font-weight: bold; }
  }

  .col-usuario{
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }



  .profile{
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    border: 1px solid var(--primary-color);
  }

  .user-info{
    min-width: 0;
    flex: 1;

    .nome{
      font-weight: 600;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .email{
      font-size: 11px;
      color: #4D4F50;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    img{
      width: 10px;
      margin-right: 4px;
    }
  }

  .location-info{
    display: flex;
    align-items: center;
    font-size: 12px;

    img{ width: 10px; margin-right: 6px; flex-shrink: 0; }
  }

  /* Selos sempre com texto: o estado nunca depende só da cor. */
  .selos{
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }

  .selo{
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;

    &.tipo-Administrador{ background: #E8EEF5; color: #26466D; border-color: #C6D3E3; }
    &.tipo-Profissional{ background: #E4F4E7; color: #1f7a33; border-color: #BFE0C5; }
    &.tipo-Comum{ background: #F1F2F4; color: #4D4F50; border-color: #DDDFE3; }

    &.status-Ativo{ background: #fff; color: #1f7a33; border-color: #BFE0C5; }
    &.status-Inativo{ background: #FDF3F3; color: #A12A2A; border-color: #F0CACA; }
    &.status-Aguardando{ background: #FFF7E5; color: #8A5A00; border-color: #F0DBA8; }
  }

  .acoes{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;

    button{
      width: auto;
      height: 28px;
      margin: 0 !important;
      padding: 0 10px;
      font-size: 11px;
      border-radius: 4px;
      cursor: pointer;
      /* Estilo base do botão primário. Antes vinha do CSS do overlay do modal
         (.content-modal button); na página (/admin/usuarios) não há overlay. */
      background: var(--primary-color);
      color: #fff;
      border: none;
    }

    .secundario{
      background: transparent;
      color: var(--primary-color);
      border: 1.2px solid var(--primary-color);
    }

    .perigo{
      background: transparent;
      color: #C43333;
      border: 1.2px solid #C43333;
    }

    .voce{
      font-size: 11px;
      color: #4D4F50;
      align-self: center;
    }
  }
`;
